import { useState } from "react";
import { admin } from "../../api/client";
import { TocaPage } from "../../components/Shell";
import { Empty, ErrorBox, JsonView, Spinner } from "../../components/ui";
import { useAsync } from "../../hooks/useAsync";
import { fmt, t } from "../../i18n";
import { dateTimeShort } from "../../lib/format";

export function TocaAuditoria() {
  const [target, setTarget] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [applied, setApplied] = useState({ target: "", from: "", to: "" });
  const { data, error, loading, reload } = useAsync(() => admin.auditLog({ target: applied.target || undefined, from: applied.from || undefined, to: applied.to || undefined }), [applied]);

  return (
    <TocaPage title={t.toca.auditTitle}>
      <form
        className="card pad"
        onSubmit={(e) => {
          e.preventDefault();
          setApplied({ target, from, to });
        }}
      >
        <div className="row" style={{ alignItems: "flex-end", gap: 12 }}>
          <div className="field" style={{ flexGrow: 1, minWidth: 200 }}>
            <label htmlFor="a-target">{t.toca.auditTarget}</label>
            <div className="inp" style={{ minHeight: 40 }}><input id="a-target" className="mono" value={target} onChange={(e) => setTarget(e.target.value)} placeholder="FXP-2026-000123, companyId, beneficiaryId…" /></div>
          </div>
          <div className="field">
            <label htmlFor="a-from">{t.common.dateFrom}</label>
            <div className="inp" style={{ minHeight: 40 }}><input id="a-from" type="date" value={from} onChange={(e) => setFrom(e.target.value)} /></div>
          </div>
          <div className="field">
            <label htmlFor="a-to">{t.common.dateTo}</label>
            <div className="inp" style={{ minHeight: 40 }}><input id="a-to" type="date" value={to} onChange={(e) => setTo(e.target.value)} /></div>
          </div>
          <button type="submit" className="btn ghost sm">{t.common.apply}</button>
          <span className="muted small" style={{ marginLeft: "auto" }}>{data ? fmt(t.common.nRecords, { n: data.length }) : ""}</span>
        </div>
      </form>
      <div className="card">
        {loading && !data ? (
          <Spinner />
        ) : error ? (
          <div style={{ padding: 16 }}><ErrorBox error={error} onRetry={reload} /></div>
        ) : !data || data.length === 0 ? (
          <Empty body={t.toca.auditEmpty} />
        ) : (
          <div className="tscroll" tabIndex={0}>
            <table>
              <thead>
                <tr>
                  <th>{t.common.date}</th>
                  <th>{t.toca.auditActor}</th>
                  <th>{t.toca.auditAction}</th>
                  <th>{t.toca.auditTarget}</th>
                  <th>{t.toca.auditMeta}</th>
                </tr>
              </thead>
              <tbody>
                {data.map((a) => (
                  <tr key={a.id}>
                    <td className="muted" style={{ whiteSpace: "nowrap" }}>{dateTimeShort(a.at)}</td>
                    <td>
                      <div className="cell2">
                        <b style={{ fontWeight: 500 }}>{t.actors[a.actorKind] ?? a.actorKind}</b>
                        <span className="mono">{a.actorId ?? ""}{a.ip ? ` · ${a.ip}` : ""}</span>
                      </div>
                    </td>
                    <td className="mono">{a.action}</td>
                    <td className="mono small">{a.target ?? "—"}</td>
                    <td style={{ minWidth: 220 }}>{a.metadata !== undefined && a.metadata !== null ? <JsonView title="metadata" value={a.metadata} /> : <span className="muted">—</span>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </TocaPage>
  );
}
